import React, { useEffect } from 'react';
import { ConfigProvider, App as AntApp } from 'antd';
import itIT from 'antd/locale/it_IT';
import { RouterProvider } from 'react-router-dom';
import { QueryProvider } from './providers/QueryProvider';
import { buildAntdTheme } from '@/theme/antd';
import { useBranding } from '@/theme/useBranding';
import { router } from './routes';
import { useFirebaseAuthSync } from '@shared/hooks/useFirebaseAuthSync';
import '@/i18n';

function ThemedApp(): React.ReactElement {
  const b = useBranding();
  useEffect(() => { if (b.loaded) document.title = `${b.appName} - Backoffice`; }, [b.loaded, b.appName]);
  return (
    <ConfigProvider theme={buildAntdTheme(b)} locale={itIT}>
        {/* T-196: monta l'holder di antd App per message/notification/modal.
            Con React 19 l'API statica `message` non si aggancia piu' (il vecchio
            render e' stato rimosso), quindi i toast non comparivano: i componenti
            devono usare App.useApp(). `component={false}` NON aggiunge alcun
            elemento nel DOM (nessun wrapper .ant-app) → nessun cambio d'aspetto
            per le altre pagine, solo il contesto per far comparire i toast. */}
        <AntApp component={false}>
          <RouterProvider router={router} />
        </AntApp>
    </ConfigProvider>
  );
}

export function App(): React.ReactElement {
  // T-89 — tiene l'ID token fresco (refresh trasparente) così la sessione dura
  // oltre le 24h senza ri-login ogni ~30-60 min.
  useFirebaseAuthSync();
  return (
    <QueryProvider>
      <ThemedApp />
    </QueryProvider>
  );
}
